module.exports = __webpack_public_path__ + "img/22.3ab91ad3.png";